import type { CI } from '@/entities/srm/ci/@x/hi';
import {
  HIHistoryHIValues,
  HIHistoryValues,
  HIHistoryValuesDTO,
} from '@/entities/monitoring/hi';
import * as z from 'zod/v4';

export interface HIValueData extends HIHistoryHIValues {
  ci?: CI;
}

export const hiValueParser = (
  data: HIHistoryValues,
  nodes: CI[],
): HIValueData[] => {
  if (!data || !nodes) {
    return [];
  }

  try {
    HIHistoryValuesDTO.parse(data);
    return data['hi_values']
      ?.map((x) => {
        const ci = nodes.find((y) => y.id === x.ci_id);

        return { ...x, ci };
      })
      ?.reduce((acc, item) => {
        const values = item?.status?.map((x) => ({ ...x, ci: item.ci })) ?? [];

        acc.push(...values);
        return acc;
      }, [])
      .toSorted((a, b) => {
        if (a?.ci && b?.ci && a['value'] === b['value']) {
          return a?.ci?.ci_name.localeCompare(b?.ci?.ci_name);
        }

        return b['value'] - a['value'];
      });
  } catch (e) {
    if (e instanceof z.ZodError) throw new Error(z.prettifyError(e));
  }
};